export const PUBLISH_STATUS_VALUE = {
  WAIT_PUBLISH: 1,
  PUBLISH: 2,
  REJECT: 3,
}
export const PUBLISH_STATUS = [
  {
    label: '待发布',
    value: PUBLISH_STATUS_VALUE.WAIT_PUBLISH,
  },
  {
    label: '已发布',
    value: PUBLISH_STATUS_VALUE.PUBLISH,
  },
  {
    label: '发布驳回',
    value: PUBLISH_STATUS_VALUE.REJECT,
  },
]
